export default __webpack_public_path__ + "static/media/2_stats1.63392175.svg";